import { colors } from '@ardoq/design-tokens';
import { Bounds } from '@ardoq/graph';
import { drawDescendantCountBadge } from 'tabview/canvasRendering/descendantCountBadge/drawDescendantCountBadge';
import type { BlocksViewNode } from '../../types';
import type { CanvasRenderingContext } from '../types';
import {
  BLOCKS_VIEW_GROUP_BACKGROUNDCOLOR,
  BLOCKS_VIEW_GROUP_BADGE_FONT_SIZE,
  BLOCKS_VIEW_GROUP_BORDERCOLOR,
  BLOCKS_VIEW_NODE_BORDERRADIUS,
  BLOCKS_VIEW_NODE_LABEL_FONT,
  BLOCKS_VIEW_NODE_LABEL_LINE_HEIGHT,
} from '../../consts';
import { rectCenter } from '../../misc/geometry';
import { drawExpander } from './drawExpander';
import { descendantCountBadgeRect } from './descendantCountBadgeRect';
import { labelRect } from './labelRect';

const drawCollapsedNonComponentGroup = (
  node: BlocksViewNode,
  cell: Bounds,
  context: CanvasRenderingContext
) => {
  if (!cell) {
    return;
  }
  const {
    displayLabel: [mainLabel],
  } = node;
  const [left, top, right, bottom] = cell;
  // #region outlined rounded rectangle
  context.strokeStyle = BLOCKS_VIEW_GROUP_BORDERCOLOR;
  context.fillStyle = BLOCKS_VIEW_GROUP_BACKGROUNDCOLOR;
  context.beginPath();
  context.roundRect(
    left,
    top,
    right - left,
    bottom - top,
    BLOCKS_VIEW_NODE_BORDERRADIUS
  );
  context.fill();
  context.stroke();
  // #endregion
  drawExpander(node, cell, colors.grey950, context);
  // #region main label
  if (mainLabel.length) {
    const [labelLeft, labelTop] = labelRect(node, cell);
    context.fillStyle = colors.grey950;
    context.textAlign = 'left';
    context.textBaseline = 'middle';
    context.font = BLOCKS_VIEW_NODE_LABEL_FONT;
    mainLabel.forEach((line, index) => {
      context.fillText(
        line,
        labelLeft,
        labelTop +
          BLOCKS_VIEW_NODE_LABEL_LINE_HEIGHT * index +
          BLOCKS_VIEW_NODE_LABEL_LINE_HEIGHT / 2
      );
    });
  }
  // #endregion
  // #region descendant count badge
  const badgeBounds = descendantCountBadgeRect(node, cell);
  const [badgeX, badgeY] = rectCenter(badgeBounds);
  drawDescendantCountBadge({
    fontSize: BLOCKS_VIEW_GROUP_BADGE_FONT_SIZE,
    x: badgeX,
    y: badgeY,
    descendantCount: node.descendantCount,
    disconnectedChildrenCount: 0,
    context,
    disconnectedNodesHighlighted: false,
    background: colors.grey900,
  });
  // #endregion
};
export { drawCollapsedNonComponentGroup };
